module.exports = __webpack_public_path__ + "static/media/快速涂鸦.40444004.png";